import { render, staticRenderFns } from "./TransactionsDialog.vue?vue&type=template&id=5bb70fa0&scoped=true"
import script from "./TransactionsDialog.vue?vue&type=script&lang=js"
export * from "./TransactionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TransactionsDialog.vue?vue&type=style&index=0&id=5bb70fa0&prod&lang=scss"
import style1 from "./TransactionsDialog.vue?vue&type=style&index=1&id=5bb70fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb70fa0",
  null
  
)

export default component.exports